import React, { useState } from "react"

import useOnclickOutside from "react-cool-onclickoutside"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { MenuItemElement } from "../../../elements/menuItem.element"
import { UtilHelper } from "../../../helpers/util.helper"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { profileSelector } from "../../../store/selectors/profile.selector"
import type { IMenuItem } from "../../../types/objects.types"
import type { IMenuProps } from "../../../types/props.types"

import barsWhite from "@front-shared/assets/images/icons/bars-white.svg"

export const AccountMenuComponent: React.FunctionComponent<
    IMenuProps
> = props => {
    const containerRef = useOnclickOutside(() => {
        props.menuItems.length && setIsSubmenuOpen(false)
    })

    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)
    const profile = useAppSelector(profileSelector)

    const toggleSubmenu = () => {
        setIsSubmenuOpen(current => !current)
    }

    return (
        <div
            className={`
                relative
                ${props.className}
            `}
            ref={containerRef}
        >
            <div
                className="
                    relative cursor-pointer flex items-center gap-[4px] px-[16px] py-[10px]
                    bg-brand-primary rounded-full border border-solid border-brand-primary
                "
                onClick={toggleSubmenu}
            >
                <PrimaryText
                    typography="buttonText"
                    className="pt-[3px]"
                    color="white"
                >
                    {UtilHelper.buildUserAbbreviation(profile)}
                </PrimaryText>

                {props.menuItems.length > 0 && (
                    <img src={barsWhite} alt="Toggle" className="ml-[6px]" />
                )}
            </div>

            {isSubmenuOpen && (
                <div
                    className="
                        absolute w-[200px] z-100 bg-brand-offWhite top-[50px] right-0
                        rounded-[8px] border border-solid border-brand-warmShadow
                        shadow-6 overflow-hidden
                    "
                >
                    <div>
                        {props.menuItems.map(
                            (item: IMenuItem, index: number) => {
                                return (
                                    <MenuItemElement
                                        key={index}
                                        item={item}
                                        className="p-[16px]"
                                        activeClassName="bg-brand-lilacLight"
                                        inactiveClassName="bg-brand-white"
                                        onClick={toggleSubmenu}
                                        typography="buttonText"
                                    />
                                )
                            },
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}
